module.exports = __webpack_public_path__ + "media/configurations/O-X-SX-SX-X-O-069a51dc.png";